import styles from './SpinnerCircle.module.scss';

const SpinnerCircle = () => {
  return <div className={styles.spinnerCircle} />;
};

export default SpinnerCircle;
